import { SelectedRadioButtonSVG } from 'src/Member/components/enrollment/components/EnrollmentIconsSvg';

const EnrollmentCoverageTypes = ({
  name,
  iconType,
  premiumValue,
  dependentCount,
}) => {
  return (
    <div className="coverage-details">
      <div className="coverage-top-row">
        <div className="coverage-radio-button">
          <SelectedRadioButtonSVG
            classNamePrimary="selected-radio-button-primary-icon"
            classNameSecondary="selected-radio-button-secondary-icon"
          />
        </div>

        <div className="coverage-icon">{iconType}</div>
        <div className="coverage-type">{name}</div>
        <div className="premium-div">
          <div className="premium-text">Premium</div>
          <div className="premium-amount">{premiumValue}</div>
          <div className="premium-text">Annual</div>
        </div>
      </div>
      <div className="coverage-row-selected">
        <div className="coverage-name-description">
          {name === 'Medical' && 'PureLife Health Suvidha Guard'}
          {name === 'Dental' && 'Tooth Fairy Pediatric Dental Clinic'}
          {name === 'Vision' && 'Vision Coverage is waived.'}
        </div>
        {dependentCount && (
          <div className="coverage-dependents-added">
            {dependentCount} Dependent Added
          </div>
        )}
      </div>
    </div>
  );
};

export default EnrollmentCoverageTypes;
